import { Gavel } from "lucide-react";

import { useTranslation } from "@/i18n";
import { formatCompactNumberID } from "@/lib/format";
import { MetricCard } from "./metric-card";

interface PolicyDecisionsCardProps {
  value: number;
  isLoading: boolean;
  isError: boolean;
}

export function PolicyDecisionsCard({
  value,
  isLoading,
  isError,
}: PolicyDecisionsCardProps) {
  const { t } = useTranslation();
  return (
    <MetricCard
      label={t("dashboard.policyDecisions.label")}
      icon={Gavel}
      isLoading={isLoading}
      isError={isError}
    >
      <div className="text-3xl font-medium text-ocean-800">
        {formatCompactNumberID(value)}
      </div>
      <div className="mt-2 text-xs text-neutral-600">
        {t("dashboard.policyDecisions.caption")}
      </div>
    </MetricCard>
  );
}
